import update from 'immutability-helper';
import seatingplanApi from '../lib/api/seatingplan';
// ------------------------------------
// Constants
// ------------------------------------

export const RECEIVE_SEATINGPLAN = 'SEATINGPLAN/LOAD_SUCCESS';
export const SELECT_SEATINGPLAN = 'SEATINGPLAN/SELECT';
// ------------------------------------
// Actions
// ------------------------------------
export function receiveSeatingplan(uuid, seatingplan) {
	return {
		type: RECEIVE_SEATINGPLAN,
		uuid,
		seatingplan,
	};
}
export function selectSeatingplan(uuid) {
	return {
		type: SELECT_SEATINGPLAN,
		uuid,
	};
}
export function fetchSeatingplan(uuid) {
	return async (dispatch) => {
		const seatingplan = await seatingplanApi.getSeatingplan(uuid);
		dispatch(receiveSeatingplan(uuid, JSON.parse(seatingplan.asJson)));
	};
}


export function fetchSeatingplanIfNeeded() {
	return {
		type: 'FFF',
	};

	/* return (dispatch, getState) => {
		if (getState().seatingplan.name == null) {
			return dispatch(fetchSeatingplan());
		}
		return Promise.resolve();
	}; */
}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[RECEIVE_SEATINGPLAN]: (state, action) => update(state, {
		elements: {
			[action.uuid]: { $set: action.seatingplan },
		},
	}),
	[SELECT_SEATINGPLAN]: (state, action) => update(state, {
		selected: { $set: action.uuid },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
	elements: {},
	selected: null,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
